export const SIGNUS_APP_URL = process.env.REACT_APP_SIGNUS_APP_URL ?? '';
export const SIGNUS_API_URL =
  process.env.REACT_APP_SIGNUS_API_URL ?? 'http://localhost:3001/api/signus';
export const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL ?? '';
/** Google OAuth web client id. Must match `externalClientId` in auth-service — that's the
 * audience its GoogleIdTokenVerifier checks, so a mismatch fails verification server-side. */
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '';

export const WSS_PATH = '/api/signus/wss';
export const WORD_RISK_ANALYSIS_WSS_NAMESPACE = '/word-risk-analysis-session-results';
export const WORD_RISK_ANALYSIS_WSS_EVENT =
  'signus-word-risk-analysis-session-result-updates-wss-event';
export const WORD_DISCUSS_WSS_NAMESPACE = '/word-discuss-session';
export const WORD_DISCUSS_WSS_EVENT = 'signus-word-discuss-session-updates-wss-event';
